import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_BIGC_BIGLINE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_BIGC_BIGLINE_API_KEY,
  },
});
